export const TASK_STATE = {
  ACTIVE: 'active',
  CLOSED: 'closed',
  IN_PROGRESS: 'inProgress',
  REVIEWED: 'reviewed',
  TO_DO: 'toDo',
  WARNING: 'warning',
}

export const TASK_STATUS = {
  ACTIVE: 'ACTIVE',
  CLOSED: 'CLOSED',
  DRAFT: 'DRAFT',
  IN_PROGRESS: 'IN_PROGRESS',
  NOT_SUBMITTED: 'NOT_SUBMITTED',
  PROGRAMMED: 'PROGRAMMED',
  SUBMITTED: 'SUBMITTED',
  TO_DO: 'TO_DO',
}
